import * as React from 'react';
import PropTypes from 'prop-types';
import {Label} from "semantic-ui-react";
import {
	TableRow,
	Toggle as MaterialToggle,
	IconButton as MaterialIconButton
} from 'material-ui';

import {togglify, asToggle, asIconButton, asInkButton, asFormLabel} from 'ah-tools';

// const _labelify = (Label) =>
// 	class extends React.Component {
// 		render = () => {
// 			const {style, ...props} = this.props;
// 			return (
// 				<Label style={{padding: '5px 8px', display: 'flex', alignItems: 'center', ...style}} {...props}/>
// 			);
// 		};
// 	};

const _tableRow = (Component) =>
	class extends React.Component {
		render = () => {
			const {onClick, ...props} = this.props;
			return <div onClick={onClick}><Component {...props}/></div>
		};
	};

// export const FormLabel = _labelify(Label);
export const IthTableRow = _tableRow(TableRow);

export const Toggle = asToggle(MaterialToggle);
export const IconButton = asIconButton(MaterialIconButton);
export const InkButton = asInkButton(MaterialIconButton);
export const FormLabel = asFormLabel(Label);


// WEBPACK FOOTER //
// ./src/extensions/index.js